<template>
  <base-sidebar-card :no-background="noBackground">
    <slot name="title">
      <v-card-title v-if="title" class="subtitle-2 font-weight-medium pb-1">
        {{ title }}
      </v-card-title>
    </slot>
    <v-row>
      <v-col cols="8" :xl="xlCols" class="py-0">
        <slot />
      </v-col>
      <v-col class="py-0 d-flex flex-column align-end">
        <slot name="buttons" />
      </v-col>
    </v-row>
  </base-sidebar-card>
</template>

<script>
import BaseSidebarCard from './BaseCard';

export default {
  name: 'AnchorSidebarBaseSplitCard',
  components: {
    BaseSidebarCard,
  },
  props: {
    xlCols: [String, Number],
    noBackground: Boolean,
    title: String,
  },
};
</script>
